import { createTooltipItems } from "../tooltips/highchartTooltip";
import { getBubblesData, getSeries } from "./helper";
import { SeriesType } from "./types";
import { nullableNumber } from "common/number-helper";
import { VisitNodePassage } from "hooks/widget-data/datapoints-api/types";
const init = (context) => {
    if (!context.staticData.customResult?.length) {
        context.staticData.customResult = [
            {
                hasColorDimension: false,
                hasData: false,
                items: [],
                series: []
            }
        ];
    }
};
export const addBubbleChartItem = (params, element, result) => {
    const z = element.measures?.[params.dataZ];
    const dataZ = typeof z === "object" && z !== null && "amount" in z ? z.amount : z;
    const item = {
        dataX: nullableNumber(element.measures?.[params.dataX]),
        dataY: nullableNumber(element.measures?.[params.dataY]),
        dataZ: nullableNumber(dataZ),
        name: element.measures?.DIMENSION
    };
    if (params.dataColor) {
        item.dataColor = (element.measures?.[params.dataColor] || "").toString();
    }
    if (params.tooltipItems?.length) {
        item.tooltips = createTooltipItems(params.tooltipItems, element.measures);
    }
    result.items.push(item);
};
export const setBubbleChartSeries = (componentProps, result) => {
    const { colorSet } = componentProps || {}, [bubblesData, hasColorDimension] = getBubblesData(result.items, colorSet);
    const data = [...bubblesData].filter((x) => x !== null);
    result.hasColorDimension = hasColorDimension;
    result.hasData = data.some((s) => s.type === SeriesType.Bubble && s.data && s.data.length > 0);
    result.series = getSeries(data, colorSet);
};
export const bubbleChart = (params) => (args) => {
    if (args.context.visitNodePassage === VisitNodePassage.NodeFirst && args.visitable) {
        init(args.context);
    }
    const [result] = args.context.staticData.customResult || [];
    if (args.context.visitNodePassage === VisitNodePassage.Leaf && args.visitable && result) {
        addBubbleChartItem(params, args.visitable, result);
    }
    if (args.context.visitNodePassage === VisitNodePassage.NodeLast && args.context.componentProps && result) {
        setBubbleChartSeries(args.context.componentProps, result);
    }
};
